import { render, staticRenderFns } from "./_detailReport.vue?vue&type=template&id=a8e0f2a2&scoped=true&lang=pug&"
import script from "./_detailReport.vue?vue&type=script&lang=js&"
export * from "./_detailReport.vue?vue&type=script&lang=js&"
import style0 from "./_detailReport.vue?vue&type=style&index=0&id=a8e0f2a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e0f2a2",
  null
  
)

export default component.exports